/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    "use strict";
/**
 *  <h3>消息提醒自动消失 </h3>
 *  <a href="../../ui_controls/bui.hint.html" target="_blank">demo</a> <br>
 *  {{#crossLink "bui.hint/option"}}{{/crossLink}}: 获取设置参数 <br>
 *  {{#crossLink "bui.hint/widget"}}{{/crossLink}}: 获取依赖控件 <br>
 *  {{#crossLink "bui.hint/hide"}}{{/crossLink}}: 隐藏 <br>
 *  {{#crossLink "bui.hint/show"}}{{/crossLink}}: 显示 <br>
 *  {{#crossLink "bui.hint/isShow"}}{{/crossLink}}: 当前状态 <br>
 *  {{#crossLink "bui.hint/remove"}}{{/crossLink}}: 移除 <br>
 *  @namespace bui
 *  @class hint
 *  @constructor 
 *  @param {object} [option] 
 *     @param option.appendTo {string} [ 在某个容器内 例如:#page ]
 *     @param option.content {string} [ 提醒的内容 ]
 *     @param option.effect {string} [ 动画效果,参考toggle ]
 *     @param option.interval {number} [ 多少秒后消失 单位:ms ]
 *     @param option.autoClose {boolean} [ 是否自动关闭 默认true | false ]
 *     @param option.close {boolean} [ 手动关闭 false | true  ]
 *     @param option.position {string} [ bottom | top ]
 *     @param option.onClose {function} [ 回调 ]
 * @example
 * 
    方法1: 快速提醒
 *
        bui.hint("确定会删除信息,不可还原");
 
 *   方法2: 可以修改更多参数
 *
       bui.hint({
            appendTo: "",
            content: "",
            interval: 2000,
            autoClose: false,      //不开启倒计时
            close: false,       //手动关闭
            position: "bottom", // bottom || top
            onClose: null
        })
 *
 */
    ui.hint = function (option,callback) {
        
        var config = {
            appendTo: "",
            content: "",
            interval: 2000,
            autoClose: true,      
            close: false,   
            opacity:0.4,        
            background:"",
            effect: "fadeInUp",
            position: "bottom",
            onClose: null
        };

        
        if( typeof option === "number" || typeof option === "string"  ){
            var opt = option || "";

            option = {};
            option.content = opt;
            option.onClose = callback || null;
        }else if( typeof option === "object" && option.content ){
            option = option ;
        }

        //方法
        var module = {
            remove: remove,
            hide: hide,
            show: show,
            isShow : isShow,
            widget: widget,
            option: options,
            config: param,
            init: init
        };

        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.hint, option );

        //z-index累计值
        var count = 0,
            uiToggle,
            effect = "",
            status = false,
            timeout;

        if( param.content ){
            init(param);
        }

        function init(option) {
            option = option || param;
            
            //生成guid
            var guid = ui.guid();

            if( option.position === "top"){
              effect = "fadeInDown";
            }else if( option.position === "bottom"){
              effect = "fadeInUp";
            }else{
              effect = option.effect;
            }

            //获取参数使用
            param = module.config = option;

            //新增信息
            render(guid, option.content, count, option.appendTo);
            ++ count ; 

            //初始化动画控制器
            uiToggle = ui.toggle({ id:"#"+guid, effect:effect });
            status = true;
            uiToggle.show();

            //开启定时
            if( option.autoClose ){

                if( timeout ){ clearTimeout(timeout) };

                //4秒自动消失
                timeout = setTimeout(function (argument) {

                    //时间到了执行回调
                    option.onClose && option.onClose.call(this,module);
                    
                    remove();

                },option.interval);
            }

            //绑定关闭按钮
            ui.obj(guid).off("click.bui",".bui-hint-close").on("click.bui",".bui-hint-close",function (argument) {
                
                remove();

                //时间到了执行回调
                option.onClose && option.onClose.call(this,module);
            })

            return this;

        }
        //渲染
        function render (guid,text,count,parentId) {
            
            //重复覆盖要在最上面
            var index = "11" + count,
                $obj = ui.obj( parentId ) || $("body"),
                //显示的位置
                position;

                switch( param.position ){
                    case "top":
                    position = "bui-hint-top";
                    break;
                    case "bottom":
                    position = "bui-hint-bottom";
                    break;
                    case "center":
                    position = "bui-hint-center";
                    break;
                }

            var bgcolor = param.background ? param.background: 'rgba(0,0,0,'+param.opacity+')';


            var html = '<div id="'+guid+'" class="bui-hint '+position+'" style="background:'+bgcolor+';z-index:'+index+'">'+text +''+ (param.close ? '<div class="bui-hint-close"><i class="icon-close"></i></div>': '')+'</div>';

            $obj.append(html);

            //有父层的时候,位置要是相对的
            if( parentId ){
              $obj.css("position","relative");
            }
        }

        /**
         * 当前的显示状态
         *  @method isShow
         *  @chainable
         *  @example 
            var uiHint = bui.hint("提醒的信息");
                uiHint.isShow();
                
         */
        function isShow() {

            return status;
        }

        /**
         * 新增提醒
         *  @method remove
         *  @chainable
         *  @param {string} text [提醒的文本]
         *  @example 
            var uiHint = bui.hint("提醒的信息");
                uiHint.remove();
                
         */
        function remove() {
            if( uiToggle ){
                status = false;
                uiToggle.hide(function (argument) {
                    uiToggle.remove();
                });
            }
            return this;
        }
        /**
         * 隐藏提醒
         *  @method hide
         *  @chainable
         *  @param {string} text [提醒的文本]
         *  @example 
            var uiHint = bui.hint({ "content": "提醒的信息", "autoClose": true});
                
                //如果一直存在,就需要手动关闭了
                uiHint.hide();
                
         */
        function hide (callback) {
            if( uiToggle ){
                status = false;
                uiToggle.hide(function (argument) {
                    callback && callback.call(this,module)
                });
            }
            return this;
        }
        /**
         * 显示提醒
         *  @method show
         *  @chainable
         *  @param {string} text [提醒的文本]
         *  @example 
            var uiHint = bui.hint({ "content": "提醒的信息", "autoClose": true});
                
                //如果一直存在,就需要手动关闭了
                uiHint.show();
                
         */
        function show (callback) {
            if( uiToggle ){
                status = true;
                uiToggle.show(function (argument) {
                    callback && callback.call(this,module)
                });
            }
            return this;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 toggle ]
         *  @example 
            
            //获取依赖控件
            var uiHintWidget = uiHint.widget();
            
                
         */
        function widget(name) {
            var control = { toggle: uiToggle };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiHint.option();

            //获取某个参数
            var id = uiHint.option( "appendTo" );

            //修改一个参数
            uiHint.option( "autoClose",true );

            //修改多个参数
            uiHint.option( {"autoClose":true} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;
    };


    return ui;

})( bui || {}, libs );
